import React, { useState, useEffect, useCallback, useRef } from "react";
import axios from "axios";
import { Badge } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

import { getUserState, getNotifications } from "../../app/selector";
import UploadButton from "../common/button/UploadButton";
import { setNotifications } from "../../features/notification/notificationSlice";
import { BACKEND_URL } from "constants";

const POLLING = 5000;

const Navigation = () => {
  const dispatch = useDispatch();
  const { loggedIn, user } = useSelector(getUserState);
  const { messages, confirms, requests } = useSelector(getNotifications);

  const pollingRef = useRef(null);

  const fetchNotifications = useCallback(() => {
    if (user) {
      axios
        .post(BACKEND_URL + "/notifications")
        .then((response) => {
          const data = response.data;
          dispatch(
            setNotifications({
              messages: data.messages,
              requests: data.requests,
              confirms: data.confirms,
              lastSeenUsers: data.lastSeenUsers,
              onlineUsers: data.onlineUsers,
            })
          );
        })
        .catch((e) => {
          console.error(e);
        });
    }
  }, [user, dispatch]);

  useEffect(() => {
    const startPolling = () => {
      pollingRef.current = setInterval(() => {
        fetchNotifications();
      }, POLLING);
    };
    fetchNotifications();
    startPolling();

    return () => {
      clearInterval(pollingRef.current);
    };
  }, [fetchNotifications]);

  const [activeTab, setActiveTab] = useState(null);

  const navigate = useNavigate();
  const goToPage = (page) => {
    navigate(page);
    setActiveTab(page);
  };

  if (!loggedIn) {
    return null;
  } else {
    return (
      <div className="profile-panel bg-light p-3 rounded">
        <h2 className="mb-4 username-truncate">
          {user.username.charAt(0).toUpperCase() + user.username.slice(1)}
        </h2>
        <UploadButton />
        <Button
          variant="outline-success raised-button"
          type="submit"
          className="mb-3"
          active={activeTab === "/profile"}
          onClick={() => goToPage("/profile")}
        >
          My Profile
        </Button>
        <Badge
          badgeContent={messages + requests + confirms}
          color="error"
          overlap="circular"
          sx={{
            "& .MuiBadge-badge": { fontSize: 16, height: 24, minWidth: 24 },
          }}
        >
          <Button
            variant="outline-success raised-button"
            type="submit"
            className="mb-3"
            active={activeTab === "/news"}
            onClick={() => goToPage("/news")}
          >
            News
          </Button>
        </Badge>

        <Button
          variant="outline-success raised-button"
          type="submit"
          className="mb-3"
          onClick={() => goToPage("/search-user")}
          active={activeTab === "/search-user"}
        >
          Search User
        </Button>
      </div>
    );
  }
};

export default Navigation;
